import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import { init } from './init'
import './styles/index.css'

init()

if (import.meta.env.VITE_ENABLE_MSW === 'true') {
  const { worker } = await import('./mocks/browser')
  await worker.start({
    serviceWorker: { url: '/mockServiceWorker.js' },
    onUnhandledRequest: 'bypass',
  })
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
